module.exports = __webpack_public_path__ + "static/media/delete.9c902574.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/Pricing/PriceList/delete.svg
// module id = 726
// module chunks = 0